import script from "./cardMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./cardMobile.vue?vue&type=script&setup=true&lang=js"

import "./cardMobile.vue?vue&type=style&index=0&id=54df7000&scoped=true&lang=less"

import exportComponent from "/workspace/office-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54df7000"]])

export default __exports__